export const groupingByOptions = [
  {label: "Sem agrupamento", value: null},
  {label: "Agrupar por setor", value: 6},
  {label: "Agrupar por tipo de serviço", value: 11},
  {label: "Agrupar por situação", value: 12},
  {label: "Agrupar por analista", value: 8},
  {label: "Agrupar por requerente", value: 9},
]
